import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/Index_1",
  },
  {
    path: "/Index_1",
    component: () => import("../views/Index_1.vue"),
  },
  {
    path: "/Index_2",
    component: () => import("../views/Index_2.vue"),
  },
  {
    path: "/Index_3",
    component: () => import("../views/Index_3.vue"),
  },
  {
    path: "/Index_4",
    component: () => import("../views/Index_4.vue"),
  },
  {
    path: "/Index_5",
    component: () => import("../views/Index_5.vue"),
  },
  {
    path: "/Index_6",
    component: () => import("../views/Index_6.vue"),
  },
  {
    path: "/Index_7",
    component: () => import("../views/Index_7.vue"),
  },
  {
    path: "/onlinebooking",
    name: "OnlineBooking",
    component: () => import("../views/onlineBooking/OnlineBooking.vue"),
    // meta:{title:"首页"},
    redirect: "/onlinebooking/classification",
    children: [
      {
        path: "classification",
        name: "classification",
        component: () => import("../views/onlineBooking/Classification.vue"),
      },
      {
        path: "list",
        name: "list",
        // meta:{
        //   title:'全部'
        // },
        component: () => import("../views/onlineBooking/List.vue"),
        //  children:[{
        //     path: 'zy',
        //     name: 'zy',
        //     meta:{
        //       title:'综艺演出'
        //     },
        //     component: () => import('../views/ZY.vue'),
        //  }]
      },
    ],
  },
  {
    path: "/article",
    name: "Article",
    component: () => import("../views/article/Article.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/news/News.vue"),
  },
  {
    path: "/characteristics",
    name: "Characteristics",
    component: () => import("../views/characteristics/Characteristics.vue"),
  },
  {
    path: "/stores",
    name: "Stores",
    component: () => import("../views/stores/Stores.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/contact/Contact.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/laoshe/",
  routes,
});

export default router;
